import { Navigate } from 'react-router-dom';
import { useIsAddonEnabled } from '@/lib/api/addons';
import { Loader2 } from 'lucide-react';

interface AddonProtectedRouteProps {
  children: React.ReactNode;
  addonSlug: string;
  redirectTo?: string;
}

/**
 * Wrapper component that protects routes behind addon enablement.
 * Redirects to add-ons settings page if the addon is not enabled.
 */
export function AddonProtectedRoute({
  children,
  addonSlug,
  redirectTo = '/settings/addons'
}: AddonProtectedRouteProps) {
  const { isEnabled, isLoading } = useIsAddonEnabled(addonSlug);

  // Show minimal loading state while checking addon status
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <Loader2 className="h-8 w-8 animate-spin text-content-tertiary" />
      </div>
    );
  }

  // Redirect if addon is not enabled
  if (!isEnabled) {
    return <Navigate to={redirectTo} replace />;
  }

  // Addon is enabled, render the route
  return <>{children}</>;
}
